/**
 * Geocode a UK postcode to [lat, lng] using postcodes.io (free, no key).
 * Returns null if the postcode is invalid, missing, or the request fails.
 */
export async function geocodePostcode(
  postcode: string | null | undefined,
): Promise<[number, number] | null> {
  if (!postcode) return null;
  const clean = postcode.replace(/\s+/g, '').toUpperCase();
  try {
    const res = await fetch(
      `https://api.postcodes.io/postcodes/${encodeURIComponent(clean)}`,
    );
    if (!res.ok) return null;
    const json = (await res.json()) as {
      status: number;
      result?: { latitude: number; longitude: number } | null;
    };
    if (json.status !== 200 || !json.result) return null;
    return [json.result.latitude, json.result.longitude];
  } catch {
    return null;
  }
}
